export const APP_PREFIX_PATH = 'techXChange';
export const API_URL  = 'https://winkdic.com/2025/B2B/server'
export const APP_LOGO = "https://winkdic.com/2025/B2B/server/logo/logo.png";
export const IMAGE_PATH = "https://winkdic.com/2025/B2B/server/images/"

